import IMask from 'imask';

export default class Forms {
    constructor() {
        this.applyMasks();
    }

    static config() {
        return {
            fieldClass: 'error-field',
            disableSubmit: true,
        };
    }

    static messages() {
        return {
            missingValue: {
                checkbox: 'Você deve aceitar a política de privacidade.',
                radio: 'Por favor selecione um valor.',
                select: 'Por favor selecione um valor.',
                'select-multiple': 'Por favor selecione pelo menos um valor.',
                text: 'Por favor preencha este campo de texto.',
                email: 'O e-mail é obrigatório.',
                tel: 'O telefone é obrigatório.',
                date: 'A data é obrigatória.',
                name: 'O nome é obrigatório.',
                default: 'Por favor preencha este campo',
                custom: {
                    cnpj: 'Informe um CNPJ válido.',
                    cpf: 'Informe um CPF válido.',
                },
            },
            patternMismatch: {
                email: 'Insira um endereço de e-mail corporativo válido.',
                url: 'Informe uma URL.',
                number: 'Informe um número válido.',
                tel: 'Informe um telefone válido.',
                date: 'Por favor utilizar o formato DD/MM/YYYY',
                cpf: 'Informe um CPF válido.',
                cnpj: 'Informe um CNPJ válido.',
                name: 'Informe um nome válido.',
                default: 'Por favor, preencha o campo com conteúdo válido.',
            },
            outOfRange: {
                over: 'Selecione um valor que não seja superior a {max}.',
                under: 'Selecione um valor que não seja inferior a {min}.',
            },
            wrongLength: {
                over: 'Reduza este texto para não mais que {maxLength} caracteres. Você está usando atualmente {length} caracteres.',
                under: 'Por favor, estenda este texto para {minLength} caracteres ou mais. Você está usando atualmente {length} caracteres.',
            },
            isNotZero: 'Por favor selecione uma opção válida.',
        };
    }

    static activeErros(form) {
        const fields = form.querySelectorAll('input, select, textarea');
        const errorMessages = [];

        fields.forEach((field) => {
            let erroCampo = field.parentElement.querySelector('.erro-campo');
            if (!erroCampo) {
                const formLine = field.closest('.form-line, .checkboxLine');
                erroCampo = formLine?.querySelector('.erro-campo');
            }

            if (field.required) {
                if (field.classList.contains('error-field')) {
                    erroCampo?.classList.remove('hidden');

                    const formLine = field.closest('.form-line, .checkboxLine');
                    let label = formLine?.querySelector('label');

                    let fieldName = '';
                    if (field.type === 'checkbox') {
                        const labelSpan = label?.querySelector('span');
                        if (labelSpan) {
                            fieldName = labelSpan.textContent.trim().substring(0, 50);
                            if (labelSpan.textContent.trim().length > 50) {
                                fieldName += '...';
                            }
                        } else {
                            fieldName = 'Aceite dos termos';
                        }
                    } else {
                        if (!label || !label.getAttribute('for') || label.getAttribute('for') !== field.id) {
                            label = form.querySelector(`label[for="${field.id}"]`);
                        }

                        if (label) {
                            const labelClone = label.cloneNode(true);
                            labelClone
                                .querySelectorAll('button, .tooltip, div[class*="tooltip"]')
                                .forEach((el) => el.remove());
                            fieldName = labelClone.textContent.trim();
                        } else {
                            fieldName = field.getAttribute('placeholder') || field.getAttribute('name');
                        }
                    }

                    const errorText = erroCampo ? erroCampo.textContent.trim() : 'Campo inválido';
                    errorMessages.push({ field: fieldName, error: errorText });
                } else {
                    erroCampo?.classList.add('hidden');
                }
            }
        });

        this.showErrorSummary(form, errorMessages);

        return errorMessages;
    }

    static showErrorSummary(form, errors) {
        let errorSummary = form.querySelector('.error-summary');

        if (errors.length === 0) {
            errorSummary?.remove();
            return;
        }

        if (!errorSummary) {
            errorSummary = document.createElement('div');
            errorSummary.className = 'error-summary mb-6 rounded-lg bg-shellred px-4 py-6 text-white';
            errorSummary.setAttribute('role', 'alert');
            errorSummary.setAttribute('aria-live', 'assertive');
            errorSummary.setAttribute('tabindex', '-1');

            form.insertBefore(errorSummary, form.firstChild);
        }

        const errorList = errors.map(({ field, error }) => `<li><strong>${field}:</strong> ${error}</li>`).join('');

        errorSummary.innerHTML = `
            <div class="mb-2 font-bold">Por favor, corrija os seguintes erros:</div>
            <ul class="list-disc pl-5 space-y-1">${errorList}</ul>
        `;

        errorSummary.focus();
        errorSummary.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    applyMasks() {
        document.querySelectorAll('.telMask').forEach((field) => {
            IMask(field, { mask: '(00) 00000-0000' });
        });

        document.querySelectorAll('.dateMask').forEach((field) => {
            IMask(field, {
                mask: Date,
                pattern: 'd/`m/`Y',
                blocks: {
                    d: { mask: IMask.MaskedRange, from: 1, to: 31 },
                    m: { mask: IMask.MaskedRange, from: 1, to: 12 },
                    Y: { mask: IMask.MaskedRange, from: 1900, to: 2099 },
                },
            });
        });

        document.querySelectorAll('.moneyMask').forEach((field) => {
            field.addEventListener('input', (e) => {
                let value = e.target.value.replace(/\D/g, '');

                if (!value || value.length === 0) {
                    e.target.value = '';
                    return;
                }

                value = (parseInt(value, 10) / 100).toFixed(2);
                value = value.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
                e.target.value = value;
            });
        });

        document.querySelectorAll('.cpfMask').forEach((field) => {
            IMask(field, { mask: '000.000.000-00' });
        });

        document.querySelectorAll('.cnpjMask').forEach((field) => {
            IMask(field, { mask: '00.000.000/0000-00' });
        });
    }

    static setLoading(button, isLoading = true) {
        if (isLoading) {
            button.classList.add('loading');
            button.disabled = true;
            button.setAttribute('aria-busy', 'true');

            const originalLabel = button.getAttribute('aria-label') || button.textContent.trim();
            button.dataset.originalLabel = originalLabel;
            button.setAttribute('aria-label', 'Enviando, aguarde...');
        } else {
            button.classList.remove('loading');
            button.disabled = false;
            button.setAttribute('aria-busy', 'false');

            if (button.dataset.originalLabel) {
                button.setAttribute('aria-label', button.dataset.originalLabel);
                delete button.dataset.originalLabel;
            }
        }
    }

    static showSuccess(form, successElement, errorElement) {
        const errorSummary = form.querySelector('.error-summary');
        errorSummary?.remove();

        errorElement.classList.add('hidden');
        successElement.classList.remove('hidden');

        if (!successElement.hasAttribute('role')) {
            successElement.setAttribute('role', 'status');
            successElement.setAttribute('aria-live', 'polite');
            successElement.setAttribute('aria-atomic', 'true');
        }

        successElement.setAttribute('tabindex', '-1');

        form.reset();

        setTimeout(() => {
            successElement.focus();
            successElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 100);
    }

    static showError(errorElement, successElement) {
        successElement.classList.add('hidden');
        errorElement.classList.remove('hidden');

        if (!errorElement.hasAttribute('role')) {
            errorElement.setAttribute('role', 'alert');
            errorElement.setAttribute('aria-live', 'assertive');
            errorElement.setAttribute('aria-atomic', 'true');
        }

        errorElement.setAttribute('tabindex', '-1');

        setTimeout(() => {
            errorElement.focus();
            errorElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 100);
    }
}
